/*
 *   File : pie.js
 *   Author : https://evoqins.com
 *   Description : Pie chart component
 *   Integrations : react-chartjs-2,chart.js
 *   Version : 1.0.0
*/

import React from 'react';

import { Pie } from 'react-chartjs-2';
import { Chart, ArcElement } from 'chart.js'

Chart.register(ArcElement);

const PieChart = (props) => {

    const DATA = {
        labels: props.label,
        datasets: [{
            label: '',
            data: props.data,
            backgroundColor: props.colors,
            // cutout: ['60%'],
            hoverOffset: 4,
            borderWidth: 1,
        }],
    };

    // let hideTooltipOnClick = false;


    const OPTIONS = {
        type: 'pie',
        data: DATA,
        responsive: true,
        onClick: (event, elements, chart) => {
            if (elements.length > 0) {
                const dataIndex = elements[0].index;  // slice index
                const path = props.paths[dataIndex]; // get id/path
                if (path) {
                    props.onNavigate(path);

                }
            }
        },
        plugins: {
            title: {
                display: false,
            },
            legend: {
                display: false,
            },
            tooltip: {
                enabled: false, // Disable default tooltip
                external: function (context) {


                    // Tooltip Element
                    let tooltipEl = document.getElementById('chartjs-tooltip');

                    // Create Tooltip Element if not exists
                    if (!tooltipEl) {
                        tooltipEl = document.createElement('div');
                        tooltipEl.id = 'chartjs-tooltip';
                        tooltipEl.style.position = 'absolute';
                        tooltipEl.style.background = '#FFFFFF';
                        tooltipEl.style.borderRadius = '8px';
                        tooltipEl.style.boxShadow =
                            '0px 8px 16px -2px rgba(27, 33, 44, 0.12)';
                        tooltipEl.style.padding = '12px';
                        tooltipEl.style.pointerEvents = 'none';
                        tooltipEl.style.transform = 'translate(0, -50%)';
                        tooltipEl.style.zIndex = '100';
                        tooltipEl.style.transition = 'opacity 0.3s ease';

                        // Inject CSS for arrow on the left
                        const style = document.createElement('style');
                        style.innerHTML = `
                            #chartjs-tooltip::after {
                                content: "";
                                position: absolute;
                                top: 50%;
                                left: -8px;
                                transform: translateY(-50%);
                                width: 0;
                                height: 0;
                                border-top: 8px solid transparent;
                                border-bottom: 8px solid transparent;
                                border-right: 8px solid #FFFFFF;
                            }
                        `;
                        document.head.appendChild(style);

                        document.body.appendChild(tooltipEl);
                    }

                    // Hide Tooltip if not active
                    const tooltipModel = context.tooltip;
                    if (tooltipModel.opacity === 0) {
                        tooltipEl.style.opacity = 0;
                        return;
                    }

                    // Set Tooltip Text with Styles
                    if (tooltipModel.dataPoints) {
                        const { datasetIndex, dataIndex } = tooltipModel.dataPoints[0];
                        const label = context.chart.data.labels[dataIndex];
                        const value = context.chart.data.datasets[datasetIndex].data[dataIndex];

                        tooltipEl.innerHTML = `
                            <div style="color: #000000; font-weight: 400; font-size: 12px; line-height: 16px;  font-family: 'Neue Plak', sans-serif;">
                               ${label}:
                                <span style="font-weight: 700;">${value}%</span>
                            </div>
                        `;
                    }

                    // Set Tooltip Position
                    const { offsetLeft, offsetTop } = context.chart.canvas;
                    tooltipEl.style.opacity = 1;
                    tooltipEl.style.left =
                        offsetLeft + tooltipModel.caretX + 'px';
                    tooltipEl.style.top =
                        offsetTop + tooltipModel.caretY + 'px';
                },
            },
        },
    };


    return (
        <div className={`${props.className ? props.className : 'e-pie-chart-wrapper'} `}>
            <Pie data={DATA}
                options={OPTIONS} />
        </div>
    )
}

export default PieChart;